

document.addEventListener('click', function (event) {

	if (!event.target.matches('.rc-radio__label')) return;

 

}, false);

function sellingPlan() {
  const items = document.querySelectorAll('[data-plans-dropdown] > option');
	if(items) {
	  items.forEach(function(item){
	    const filter = item.text.replace('Delivery every ','')
	    item.innerHTML = filter;
	  })
	}
}

function addToCart(value) {
  const button = document.querySelector('.product-form--atc-button')
  if(button){
		button.innerHTML = value
	}
}

const accordions = document.querySelectorAll('.accordion');
if(accordions) {
	const openAccordion = (accordion) => {
		const content = accordion.querySelector('.accordion__content');
		accordion.classList.add('accordion__active');
		content.style.maxHeight = content.scrollHeight + 'px';
	};
	const closeAccordion = (accordion) => {
		const content = accordion.querySelector('.accordion__content');
		accordion.classList.remove('accordion__active');
		content.style.maxHeight = null;
	};
	accordions.forEach((accordion) => {
		const intro = accordion.querySelector('.accordion__intro');
		const content = accordion.querySelector('.accordion__content');

		intro.onclick = () => {
			if (content.style.maxHeight) {
				closeAccordion(accordion);
			} else {
				accordions.forEach((accordion) => closeAccordion(accordion));
				openAccordion(accordion);
			}
		};
	});
	if(accordions[0]) {
		const intro = accordions[0].querySelector('.accordion__intro');
		const content = accordions[0].querySelector('.accordion__content');
		openAccordion(accordions[0]);
	}
}

function replaceDiscountTitle() {
	const text = document.querySelector('.quantity-breaks-now-discount-description')
	if(text) {
		text.innerHTML = 'Bulk buy & save even more…';
	}
}

function productSKU() {
	const select = document.querySelector('.template-product .variants-ui__select-main')
	if(select) {
		const sku = document.querySelector('.template-product .product-sku')
		if(sku) {
			select.addEventListener('change', (event) => {
				sku.textContent = 'SKU: ' + select[select.selectedIndex].dataset.sku
			})
		}
	}
}

function productCompare() {

	const select = document.querySelector('.variants-ui__select-main')
	const compare = document.querySelector('.product-pricing .price__compare-at .price__compare-at--single')

    if(select) {
      if(compare) {
        const value = Number(select[select.selectedIndex].dataset.compare_at_price);
        select.addEventListener('change', (event) => {
          const value = Number(select[select.selectedIndex].dataset.compare_at_price);
					console.log(value)
					console.log(compare)
          if(value) {
            compare.innerHTML = Shopify.formatMoney(value).replace('$', '£');
          } else {
            compare.innerHTML = ''
          }
        })
      }
    }
}

function cookieAnnouncement() {
	let announcement = document.cookie.match('announcement');
	if(!announcement) {
		document.querySelector('.announcement-bar').style.display = 'block';
		document.body.classList.add('announcement-bar-show');
		document.body.classList.remove('announcement-bar-hide');
	} else {
		document.body.classList.remove('announcement-bar-show');
		document.body.classList.add('announcement-bar-hide');
	}
}

function closeAnnouncement() {
	const button = document.querySelector('.announcement-bar .announcement-bar-close')
	if(button){
		button.addEventListener('click', function () {
			document.querySelector('.announcement-bar').classList.add('hide');
			document.body.classList.remove('announcement-bar-show');
			document.body.classList.add('announcement-bar-hide');
			document.cookie = `announcement=hide; path=/; max-age=${30};`;
		})
	}
}

function wrapYoutube() {
	const videos = document.querySelectorAll('.fr-video');
	if(videos) {
		videos.forEach(function (video, index) {
			const wrapper = document.createElement('div');
			for (let itemContent of video.childNodes) {
				wrapper.appendChild(itemContent);
			}
			video.appendChild(wrapper);
		});
	}
}

function collection() {
	const collectionGlide = document.querySelector('.glide');
	if(collectionGlide) {
		var glide = new Glide(collectionGlide, {
		  type: 'slider',
			startAt: 1,
		  perView: 8,
			gap: '30',
			bound: true,
			rewind: false,
			peek: {
				before: 0,
				after: 0
			},
			breakpoints: {
				1400: {
					perView: 7,
					gap: '30',
					peek: {
						before: 0,
						after: 0
					}
				},
				1200: {
					perView: 6,
					gap: '30',
					peek: {
						before: 0,
						after: 0
					}
				},
				1079: {
					perView: 5,
					gap: '30',
					peek: {
						before: 0,
						after: 50
					}
				},
				992: {
					perView: 4,
					gap: '30',
					peek: {
						before: 0,
						after: 50
					}
				},
				768: {
					perView: 3,
					gap: '15',
					peek: {
						before: 0,
						after: 50
					}
				},
				576: {
					perView: 2,
					gap: '15',
					peek: {
						before: 0,
						after: 50
					}
				},
				375: {
					perView: 1,
					gap: '15',
					peek: {
						before: 60,
						after: 60
					}
				}
			}
		})
		glide.mount()
	}
}

function reviews() {
	const stars = document.querySelector('.reviewio-stars')
	if(stars) {
		fetch('https://api.reviews.io/merchant/latest?store=oceansalive-co-uk').then(function (response) {
			return response.json();
		}).then(function (data) {
			const formula = (data.stats.average_rating * 100 / 5).toFixed(2);
			document.querySelector('.utility-bar .reviewio-stars .word').innerHTML = '<span>' + data.word + '</span> <span>' + data.stats.average_rating + ' out of 5</span>'
			document.querySelector('.utility-bar .reviewio-stars .ratings .full-stars').style.width = formula + '%';
			document.querySelector('.site-header-main .reviewio-stars .word').innerHTML = '<span>' + data.word + '</span> <span>' + data.stats.average_rating + ' out of 5</span>'
			document.querySelector('.site-header-main .reviewio-stars .ratings .full-stars').style.width = formula + '%';
		}).catch(function (error) {
			console.warn(error);
		});
	}
}

function announmentMobile() {

	const announcement = document.querySelector('#shopify-section-static-announcement');
	const header = document.querySelector(".site-header");
	const utility = document.querySelector("#shopify-section-static-utility-bar");

	if(window.innerWidth < 679){
		header.after(announcement);
	} else{
		announcement.after(utility);
	}

	if(announcement) {
		window.addEventListener("resize", function(){
			if(window.innerWidth < 679){
				header.after(announcement);
			} else{
				announcement.after(utility);
				utility.after(header);
			}
		});
	}
}

this.reorder = new function() {
    var c = this;
    this.pushQueue = function(t, n, i) {
        n[t].check_inventory && (n[t].quantity = Math.min(parseInt(n[t].inventory), parseInt(n[t].quantity))), $.ajax({
            url: "/cart/add.js",
            method: "POST",
            data: {
                quantity: n[t].quantity,
                id: n[t].id
            },
            complete: function(e) {
                t >= n.length - 1 ? (i.removeClass("loading"), window.location.href = "/cart") : c.pushQueue(t + 1, n, i)
            }
        })
    }, this.listen = function() {
        var e = $(this),
            t = e.attr("data-variant-ids").split(","),
            n = e.attr("data-variant-quantities").split(","),
            i = e.attr("data-variant-inventories").split(","),
            o = e.attr("data-variant-inventory-policies").split(","),
            r = e.attr("data-variant-inventory-trackers").split(",");
        t.splice(-1, 1), n.splice(-1, 1), i.splice(-1, 1), o.splice(-1, 1), r.splice(-1, 1);
        for (var a = [], s = 0; s < t.length; s++) a.push({
            id: t[s],
            quantity: n[s],
            inventory: i[s],
            check_inventory: "deny" == o[s] && "" != r[s]
        });
        e.addClass("loading"), c.pushQueue(0, a, e)
    }, this.init = function() {
        $(".reorder-btn").on("click", c.listen)
    }
}, $(reorder.init);

collection()
wrapYoutube()
replaceDiscountTitle()
productSKU()
closeAnnouncement()
cookieAnnouncement()
announmentMobile()
reviews()


window.onload = function() {
  productCompare();
};


